module.exports = __webpack_public_path__ + "087822eb4f7ae87069865489f033bef2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/pineapple-head.png
// module id = 2935
// module chunks = 0